import { render, staticRenderFns } from "./ServiceDataOverview.vue?vue&type=template&id=5af853d7&scoped=true"
import script from "./ServiceDataOverview.vue?vue&type=script&lang=js"
export * from "./ServiceDataOverview.vue?vue&type=script&lang=js"
import style0 from "./ServiceDataOverview.vue?vue&type=style&index=0&id=5af853d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af853d7",
  null
  
)

export default component.exports